function getBypassAccess() {
    return localStorage.getItem("bypass_maintenance") === "true";
}

function saveBypassAccess() {
    localStorage.setItem("bypass_maintenance", "true");
}

function saveUserToken(token, remember) {
    document.cookie = "user_token=" + token + "; expires=Thu, 18 Dec 2050 12:00:00 UTC; path=/";
}

function getUserToken() {
    var token = getCookie("user_token");
    if (token !== null && token !== '') {
        return token;
    } else {
        var token = getCookie("user_token");
        if (token !== null && token !== '') {
            return token;
        }
    }
}

function LogoutUser() {
    document.cookie = 'user_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const getFlag = (country) => {
    if (country === "KSA")
        return 'https://flagcdn.com/h80/sa.png';
    else if (country === "UAE")
        return 'https://flagcdn.com/h80/ae.png';
    else if (country === "Kuwait")
        return 'https://flagcdn.com/h80/kw.png';
    else if (country === "Bahrain")
        return 'https://flagcdn.com/h80/bh.png';
    else if (country === "Qatar")
        return 'https://flagcdn.com/h80/qa.png';
    else if (country === "Oman")
        return 'https://flagcdn.com/h80/om.png';
}

const setSearch = (key = '', companysearch = '') => {
    window.sessionStorage.setItem(key, companysearch);
}

const removeSearch = (key = '') => {
    return window.sessionStorage.removeItem(key);
}

const getSearch = (key = '') => {
    return window.sessionStorage.getItem(key);
}

const setDocumentUrl = (url = "") => {
    window.localStorage.setItem('document_url', url);
}

const getDocumentUrl = () => {
    return window.localStorage.getItem('document_url');
}

const setDocumentOpenName = (name = "") => {
    window.localStorage.setItem('document_open_url', name);
}

const getDocumentOpenName = () => {
    return window.localStorage.getItem('document_open_url');
}

const setDocumentCompanySymbol = (name = "") => {
    window.localStorage.setItem('document_company_symbol', name);
}

const getDocumentCompanySymbol = () => {
    return window.localStorage.getItem('document_company_symbol');
}

// ✅ تصدير جميع الدوال بما فيها الجديدة
export {
    getBypassAccess,
    saveBypassAccess,
    saveUserToken,
    getUserToken,
    LogoutUser,
    getFlag,
    setSearch,
    removeSearch,
    getSearch,
    setDocumentUrl,
    getDocumentUrl,
    setDocumentOpenName,
    getDocumentOpenName,
    setDocumentCompanySymbol,
    getDocumentCompanySymbol
};
